import React, { Fragment, useState, useEffect } from 'react';
import { useNavigate, useParams, useMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createCotation, getCotationById } from '../../actions/cotation';
import Spinner from '../layout/Spinner';
import Form from 'react-bootstrap/Form';
import { useTranslation, Trans } from 'react-i18next';

const CotationCreate = ({
  auth,
  createCotation,
  getCotationById,
  history,
  cotation: { cotation, loading }
}) => {
  const initialFormData = {
    manufacturer: '',
    model: '',
    generation: '',
    version: '',
    description: '',
    serialnumber: '',
    cote_longueur_fleche: '',
    cote_longueur_bras: '',
    cote_A: '',
    cote_B: '',
    cote_I: '',
    cote_H: '',
    cote_h2: '',
    cote_I1: '',
    cote_I2: '',
    cote_W: '',
    cote_N: '',
    cote_N1: '',
    cote_Q: '',
    cote_Q1: '',
    cote_Z: '',
    cote_R3: '',
    cote_X3: '',
    cote_L: '',
    cote_X3L: '',
    cote_W1: '',
    cote_p: '',
    cote_r: '',
    cote_s: '',
    cote_Hg: '',
    cote_Lg: '',
    cote_Pg: '',
    cote_F: '',
    cote_Fh: '',
    cote_Fv: '',
    cote_Tt: '',
    cote_Ht: '',
    cote_Dout1: '',
    cote_Drod1: '',
    cote_Dout2: '',
    cote_Drod2: '',
    cote_lambda_max_verin_bal: '',
    cote_lambda_min_verin_bal: '',
    cote_Dout3: '',
    cote_Drod3: '',
    cote_lambda_max_verin_god: '',
    cote_lambda_min_verin_god: '',
    cote_const_LP: '',
    cote_const_HB: '',
    cote_const_LC: '',
    cote_const_LA: '',
    cote_const_D: '',
    cote_const_RR: '',
    cote_const_HA: '',
    cote_const_HC: '',
    cote_const_GS: '',
    cote_const_V: '',
    cote_const_LH: ''
  };

  const { t } = useTranslation();
  const { id } = useParams();
  const [formData, setFormData] = useState(initialFormData);
  const navigate = useNavigate();
  const [action, setaction] = useState(false);

  const newCotation = useMatch('/create-cotation');

  useEffect(() => {
    if (!cotation && !newCotation) {
      getCotationById(id);
    }
    if (!loading) {
      if (!newCotation) {
        const cotationData = { ...initialFormData };
        for (const key in cotation) {
          if (key in cotationData) cotationData[key] = cotation[key];
        }
        setFormData(cotationData);
      } else {
        setFormData(initialFormData);
      }
    }
  }, [loading, cotation, id, getCotationById, newCotation]);

  const identityList = [
    'manufacturer',
    'model',
    'generation',
    'version',
    'description',
    'serialnumber'
  ];

  const manufacturerList = [
    'cote_const_LP',
    'cote_const_HB',
    'cote_const_LC',
    'cote_const_LA',
    'cote_const_D',
    'cote_const_RR',
    'cote_const_HA',
    'cote_const_HC',
    'cote_const_GS',
    'cote_const_V',
    'cote_const_LH'
  ];

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const res = await createCotation(
      cotation ? cotation._id : null,
      formData,
      navigate
    );

    if (res && res.status === 200) {
      setaction(true);
      setTimeout(() => {
        navigate(`/cotation/${cotation._id}`);
      }, 1000);
    }
  };

  const identityFields = identityList
    .filter((field) => field !== 'description')
    .map((field) => (
      <Form.Group key={field} controlId={field} className="col-md-2">
        <Form.Control
          type="text"
          placeholder={field.replace(/_/g, ' ')}
          name={field}
          value={formData[field]}
          onChange={onChange}
          required={field === 'manufacturer' || field === 'model'}
          style={{ margin: 3 }}
        />
      </Form.Group>
    ));

  const measureFields = Object.keys(initialFormData)
    .filter((field) => !identityList.includes(field))
    .filter((field) => !manufacturerList.includes(field))
    .map((field) => (
      <Form.Group key={field} controlId={field} className="col-md-2">
        <Form.Control
          type="number"
          placeholder={field.replace(/_/g, ' ')}
          name={field}
          value={formData[field]}
          onChange={onChange}
          style={{ margin: 3 }}
        />
      </Form.Group>
    ));

  const manufacturerFields = Object.keys(initialFormData)
    .filter((field) => manufacturerList.includes(field))
    .map((field) => (
      <Form.Group key={field} controlId={field} className="col-md-2">
        <Form.Control
          type="number"
          placeholder={field.replace(/_/g, ' ')}
          name={field}
          value={formData[field]}
          onChange={onChange}
          style={{ margin: 3 }}
        />
      </Form.Group>
    ));

  // loading || auth === null ||
  return (
    <section className="container">
      {action || loading ? (
        <Spinner />
      ) : (
        <Fragment>
          <Fragment>
            <h2
              className="p-3 mb-1 bg-ascorel text-white text-center"
              style={{ marginTop: 10 }}
            >
              {newCotation ? (
                <Trans>{t('titre_creer')}</Trans>
              ) : (
                <Trans>{t('titre_modifier')}</Trans>
              )}
            </h2>

            <Form onSubmit={onSubmit}>
              <h3>Identité Pelle</h3>
              <div className="row">{identityFields}</div>
              <Form.Group
                key={'description'}
                controlId={'description'}
                className="col-md-10"
                style={{ marginTop: 3 }}
              >
                <Form.Control
                  type="text"
                  placeholder={'description'}
                  name={'description'}
                  value={formData['description']}
                  onChange={onChange}
                  required={false}
                />
              </Form.Group>
              <h3 style={{ marginTop: 30 }}>Mesures pesage (en millimètres)</h3>
              <div className="row">{measureFields}</div>
              <h3 style={{ marginTop: 30 }}>
                Mesures constructeur (en millimètres)
              </h3>
              <div className="row">{manufacturerFields}</div>
              <div
                style={{ marginTop: 30 }}
                className="d-flex justify-content-center"
              >
                <input
                  type="submit"
                  className="btn btn-ascorel my-1 mx-2"
                  value={newCotation ? t('create') : t('update')}
                />
                <button
                  type="button"
                  className="btn btn-light my-1 mx-2"
                  onClick={() => navigate(-1)}
                >
                  {t('cancel')}
                </button>
              </div>
            </Form>
          </Fragment>
        </Fragment>
      )}
    </section>
  );
};

CotationCreate.propTypes = {
  createCotation: PropTypes.func.isRequired,
  getCotationById: PropTypes.func.isRequired,
  cotation: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  cotation: state.cotation,
  auth: state.auth
});

export default connect(mapStateToProps, { createCotation, getCotationById })(
  CotationCreate
);
